// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");

// Views

const Dashboard = () => import("@/views/Dashboard");
const Home = () => import("@/views/home");
const UnderConstruction = () => import("@/views/under-construction");
const Careers = () =>
    import("@/views/client-views/careers/careersComponent.vue");
const LayoutContainer = () =>
    import(
        "@/views/client-views/layout-container/layoutContainerComponent.vue"
    );
const CascoOffer = () =>
    import("@/views/client-views/casco-offer/cascoOfferComponent.vue");
const HomeOffer = () =>
    import("@/views/client-views/home-offer/homeOfferComponent.vue");
const RCAOffer = () =>
    import("@/views/client-views/rca-offer/rcaOfferComponent.vue");

const FinishOrder = () =>
    import("@/views/client-views/rca-offer/finishOrder.vue");

const DownloadPolicy = () =>
    import("@/views/client-views/rca-offer/downloadPolicy.vue");


const Offers = () => import("@/views/client-views/offers/offersComponent.vue");
const CompleteList = () =>
    import("@/views/client-views/complete-list/completeList.vue");

const MyOrderList = () =>
    import("@/views/client-views/my-orders/myOrderList.vue");

const OrderList = () => import("@/views/Order/index.vue");
const TempOrderList = () => import("@/views/Order/tempOrderList.vue");
const Order = () => import("@/views/Order/edit.vue");

const ExpiringOrderList = () => import("@/views/Order/expiring.vue");
const PaymentsList = () => import("@/views/Order/payments.vue");

const PolicyList = () => import("@/views/Policy/index.vue");
const Policy = () => import("@/views/Policy/edit.vue");

//BlacklistCar
const Blacklist = () => import("@/views/Blacklist/index.vue");
const BlacklistVehicle = () => import("@/views/Blacklist/edit.vue");

const OrderTypeList = () => import("@/views/OrderType/index.vue");
const OrderType = () => import("@/views/OrderType/edit.vue");

const OwnerList = () => import("@/views/Owner/index.vue");
const Owner = () => import("@/views/Owner/edit.vue");

const UserList = () => import("@/views/User/index.vue");
const User = () => import("@/views/User/edit.vue");

// Views - Pages
const Page404 = () => import("@/views/Pages/Page404.vue");
const WorkInProgress = () => import("@/views/Pages/WorkInProgress.vue");
const Page500 = () => import("@/views/Pages/Page500.vue");
const Login = () => import("@/views/Pages/Login.vue");
const Register = () => import("@/views/Pages/Register.vue");
const AccountActivation = () => import("@/views/Pages/AccountActivation.vue");
const PasswordReset = () => import("@/views/Pages/PasswordReset.vue");
const ForgotPassword = () => import("@/views/Pages/ForgotPassword.vue");

//import Login from '@/views/Pages/Login.vue'

const routes = [
    {
        //path: "/",
        //name: "UnderConstruction",
        //component: UnderConstruction,

        path: "/",
        name: "Home",
        component: LayoutContainer,
        meta: { requiresAuth: false },
        children: [
            {
                path: "accountActivation/:id",
                name: "AccountActivation",
                component: AccountActivation,
                meta: { requiresAuth: false}
            },
            {
                path: "passwordReset/:id/:userName",
                name: "PasswordReset",
                component: PasswordReset,
                meta: {
                    requiresAuth: false,
                    breadcrumbText: "Reseteaza parola"
                }
            },
            {
                path: "login",
                name: "Login",
                component: Login,
                meta: { requiresAuth: false, breadcrumbText: "Login" }
            },
            {
                path: "/",
                name: "Home",
                component: Home,
                meta: { requiresAuth: false }
            },
            {
                path: "oferte",
                name: "Offers",
                component: Offers,
                meta: { requiresAuth: false }
            },
            {
                path: "oferte/fb",
                name: "Offers",
                component: Offers,
                meta: { requiresAuth: false }
            },
            {
                path: "order/add/:type",
                name: "RCA",
                component: RCAOffer,
                meta: { requiresAuth: false }
            },
            {
                path: "cariera",
                name: "Careers",
                component: Careers,
                meta: { requiresAuth: false }
            },
            {
                path: "toate-asigurarile",
                name: "CompleteList",
                component: CompleteList,
                meta: { requiresAuth: false }
            },
            {
                path: "order/finish",
                name: "FinishOrder",
                component: FinishOrder,
                meta: { requiresAuth: false },
                props: true
            },
            {
                path: "order/:id/download",
                name: "DownloadPolicy",
                component: DownloadPolicy,
                meta: { requiresAuth: false },
                props: true
            },
            {
                path: "wip",
                name: "WorkInProgress",
                component: WorkInProgress
            },
            {
                path: "forgotPassword",
                name: "ForgotPassword",
                component: ForgotPassword,
                meta: {
                    requiresAuth: false,
                    breadcrumbText: "Reamintire parola"
                }
            },
            {
                path: "politele-mele",
                name: "MyOrderList",
                component: MyOrderList,
                meta: { requiresAuth: false }
            },
        ]
    },
    {
        path: "/crm",
        redirect: "/crm/home",
        name: "CrmHome",
        component: DefaultContainer,
        children: [
            {
                path: "home",
                name: "Dashboard",
                component: Dashboard,
                meta: { requiresAuth: true, breadcrumbText: "Dashboard" }
            },

            // Order

            {
                path: "orders/confirmed",
                name: "ConfirmedOrderList",
                component: OrderList,
                meta: { requiresAuth: true, breadcrumbText: "Comenzi agenti" }
            },
            {
                path: "orders/online-confirmed",
                name: "OnlineConfirmedOrderList",
                component: OrderList,
                meta: { requiresAuth: true, breadcrumbText: "Comenzi online" }
            },
            {
                path: "orders/request",
                name: "RequestOrderList",
                component: TempOrderList,
                meta: { requiresAuth: true, breadcrumbText: "Oferte salvate" }
            },

            {
                path: "order/add/:type",
                name: "addOrder",
                component: Order,
                meta: {
                    requiresAuth: true,
                    breadcrumbText: "Adauga comanda",
                    parentRoute: {
                        path: "crm/orders/confirmed",
                        breadcrumbText: "Comenzi"
                    }
                }
            },
            {
                path: "order/edit/:id",
                name: "editOrder",
                component: Order,
                meta: {
                    requiresAuth: true,
                    breadcrumbText: "",
                    parentRoute: {
                        path: "crm/orders/confirmed",
                        breadcrumbText: "Comenzi"
                    }
                }
            },
            {
                path: "order/view/:id",
                name: "viewOrder",
                component: Order,
                meta: {
                    requiresAuth: true,
                    breadcrumbText: "",
                    parentRoute: {
                        path: "crm/orders/confirmed",
                        breadcrumbText: "Comenzi"
                    }
                }
            },

            {
                path: "offer/edit/:id",
                name: "editOffer",
                component: Order,
                meta: {
                    requiresAuth: true,
                    breadcrumbText: "Oferta",
                    parentRoute: {
                        path: "crm/orders/request",
                        breadcrumbText: "Oferte salvate"
                    }
                }
            },
            {
                path: "offer/view/:id",
                name: "viewOffer",
                component: Order,
                meta: {
                    requiresAuth: true,
                    breadcrumbText: "Oferta",
                    parentRoute: {
                        path: "crm/orders/request",
                        breadcrumbText: "Oferte salvate"
                    }
                }
            },

            {
                path: "order/renew/:id",
                name: "renewOrder",
                component: Order,
                meta: { requiresAuth: true, breadcrumbText: "Reinoire polita" }
            },

            {
                path: "orders/expiring",
                name: "",
                component: ExpiringOrderList,
                meta: { requiresAuth: true, breadcrumbText: "Expirari" }
            },
            {
                path: "orders/payments",
                name: "PaymentsList",
                component: PaymentsList,
                meta: { requiresAuth: true, breadcrumbText: "Rate scadente" }
            },

            // Owner
            {
                path: "owners",
                name: "Proprietari",
                component: OwnerList,
                meta: { requiresAuth: true, breadcrumbText: "Proprietari" }
            },
            {
                path: "owner/:id",
                name: "Proprietar",
                component: Owner,
                meta: { requiresAuth: true, breadcrumbText: "Proprietar" }
            },

            //Blacklist
            {
                path: "blacklist",
                name: "Blacklist",
                component: Blacklist,
                meta: { requiresAuth: true, breadcrumbText: "Blacklist" }
            },
            {
                path: "BlacklistVehicle/:id",
                name: "BlacklistVehicle",
                component: BlacklistVehicle,
                meta: {
                    requiresAuth: true,
                    breadcrumbText: "Autovehicul",
                    parentRoute: {
                        path: "blacklist",
                        breadcrumbText: "Blacklist"
                    }
                }
            },

            // Order type
            {
                path: "orderType",
                name: "OrderTypeList",
                component: OrderTypeList,
                meta: { requiresAuth: true, breadcrumbText: "Tipuri de polite" }
            },
            {
                path: "orderType/:id",
                name: "OrderType",
                component: OrderType,
                meta: {
                    requiresAuth: true,
                    breadcrumbText: "Tip polita",
                    parentRoute: {
                        path: "orderType",
                        breadcrumbText: "Tipuri de polite"
                    }
                }
            },

            // Users
            {
                path: "users",
                name: "userList",
                component: UserList,
                meta: { requiresAuth: true, breadcrumbText: "Utilizatori" }
            },
            {
                path: "user/:id",
                name: "editUser",
                component: User,
                meta: {
                    requiresAuth: true,
                    breadcrumbText: "Utilizator",
                    parentRoute: {
                        path: "users",
                        breadcrumbText: "Utilizatori"
                    }
                }
            }
        ]
    },
    {
        path: "/crm/pages",
        redirect: "/pages/404",
        name: "Pages",
        component: {
            render(c) {
                return c("router-view");
            }
        },

        children: [
            {
                path: "wip",
                name: "WorkInProgress",
                component: WorkInProgress
            },
            {
                path: "404",
                name: "Page404",
                component: Page404
            },
            {
                path: "500",
                name: "Page500",
                component: Page500
            },
            {
                path: "register",
                name: "Register",
                component: Register,
                meta: {
                    requiresAuth: false,
                    breadcrumbText: "Inregistrare utilizator"
                }
            },
            {
                path: "login",
                name: "Login",
                component: Login,
                meta: { requiresAuth: false, breadcrumbText: "Login" }
            },
            {
                path: "accountActivation/:id/:token",
                name: "AccountActivation",
                component: AccountActivation,
                meta: { requiresAuth: false, breadcrumbText: "Activeaza cont" }
            },
            {
                path: "passwordReset/:id/:userName",
                name: "PasswordReset",
                component: PasswordReset,
                meta: {
                    requiresAuth: false,
                    breadcrumbText: "Reseteaza parola"
                }
            },
            {
                path: "forgotPassword",
                name: "ForgotPassword",
                component: ForgotPassword,
                meta: {
                    requiresAuth: false,
                    breadcrumbText: "Reamintire parola"
                }
            }
        ]
    },
    //{
    //    path: "*",
    //    component: Login
    //}
];
export default routes;

//export const AppRoutes = routes;
